import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Type from "./Type";
import About from "../About/About";
import Projects from "../Projects/Projects";
import Upwork from "../../../src/Assets/social icons/upwork.svg";
import whatsapp from "../../../src/Assets/social icons/whatsapp.svg";
import facebook from "../../../src/Assets/social icons/facebook.svg";
import instagram from "../../../src/Assets/social icons/instagram.svg";
import x from "../../../src/Assets/social icons/logo-x.png";
import Linkedin from "../../../src/Assets/social icons/Linkedin.svg";
import youtube from "../../../src/Assets/social icons/youtube.svg";
import github from "../../../src/Assets/social icons/github.svg";
function Home() {
  return (
    <section id="home-section">
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>
              <h1 className="heading-name">
                I'M
                <strong className="main-name"> MOHAMED GAMAL</strong>
              </h1>
              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>
            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Container className="links">
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Contact Me Now</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://www.upwork.com/freelancers/~01e2eafb1befdc17cf"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <img
                    src={Upwork}
                    alt=""
                    className="img-fluid"
                    style={{ maxHeight: "70px" }}
                  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="http://wa.me/+201100784118"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <img
                    src={whatsapp}
                    alt=""
                    className="img-fluid"
                    style={{ maxHeight: "70px" }}
                  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=100006153453395"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <img
                    src={facebook}
                    alt=""
                    className="img-fluid"
                    style={{ maxHeight: "70px" }}
                  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/mohamed_gmall_h?r=nametag"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <img
                    src={instagram}
                    alt=""
                    className="img-fluid"
                    style={{ maxHeight: "70px" }}
                  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/Mohamed90202495?t=kN8jNNpBdyj71HjNkJP8CA&s=09"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <img
                    src={x}
                    alt=""
                    className="img-fluid"
                    style={{ maxHeight: "70px" }}
                  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/mohamed-gamal-1a95a0232/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <img
                    src={Linkedin}
                    alt=""
                    className="img-fluid"
                    style={{ maxHeight: "70px" }}
                  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://youtube.com/channel/UCxTEnUwdpTL4Dgy1PpifSlA"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <img
                    src={youtube}
                    alt=""
                    className="img-fluid"
                    style={{ maxHeight: "70px" }}
                  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/Mohamed-Gamal-G"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <img
                    src={github}
                    alt=""
                    className="img-fluid"
                    style={{ maxHeight: "70px" }}
                  />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
      <About />
      <Projects />
    </section>
  );
}
export default Home;